import React from "react";
import { StyledPillButton } from "./PillButtonStyles";
import { PillButtonPropTypes } from "./PillButtonTypes";

export const PillButton: React.FC<PillButtonPropTypes> = ({
  pillButtonClickHandler,
  buttonText,
  startIcon,
  endIcon,
  disabled,
  color,
  backgroundColor,
  refEl,
  height,
  width,
  className,
}: PillButtonPropTypes) => {
  return (
    <StyledPillButton
      ref={refEl || null}
      data-testid={"pillButton"}
      disabled={disabled}
      className={className}
      customColor={color}
      customBackgroundColor={backgroundColor}
      variant="outlined"
      onClick={() => pillButtonClickHandler()}
      startIcon={
        typeof startIcon === "string" ? <img src={startIcon} /> : startIcon
      }
      endIcon={typeof endIcon === "string" ? <img src={endIcon} /> : endIcon}
      sx={{
        height: height || "100%",
        width: width || "100%",
        flexGrow: height || width ? 0 : 1,
        padding: "8px 16px",
      }}
    >
      {buttonText}
    </StyledPillButton>
  );
};
